import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class MarketingOrdersAreasService {
  private apiService = inject(ApiService);

  private cachedAreas$: Observable<string[]>;
  private cachedPackageTitles$: Observable<string[]>;
  private cachedPackages$: Observable<string[]>;

  /**
   * Get all options.
   */
  getAreas$(brandCodes = []): Observable<string[]> {
    return this.apiService.get<string[]>('marketing-orders/areas', { brandCodes: brandCodes.join(',') });
  }

  getPackages$(): Observable<string[]> {
    if (!this.cachedPackages$) {
      this.cachedPackages$ = this.apiService.get<string[]>('package-instances/my-packages');
      if (this.cachedPackages$) {
        this.getPackagesArray(this.cachedPackages$);
      }
    }
    return this.cachedPackageTitles$;
  }

  getPackagesArray(data) {
    const packArray = [];
    data.forEach((element) => {
      element.filter((dt) => {
        if (dt?.title) {
          packArray.push(`${dt.title}-${dt.code}`);
        }
      });
    });
    this.cachedPackageTitles$ = of(packArray);
  }
}
